"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractEndpoint = extractEndpoint;
var isDevelopmentAddress_1 = require("./isDevelopmentAddress");
function extractEndpoint(url, subdomain) {
    var parts = url.split('.');
    var domain = !(0, isDevelopmentAddress_1.isDevelopmentAddress)(url) && isDomainName(parts)
        ? buildEndpoint(parts)
        : 'staging-boclips.com';
    return "https://".concat(subdomain, ".").concat(domain);
}
function buildEndpoint(parts) {
    return [parts[parts.length - 2], parts[parts.length - 1]].join('.');
}
function isDomainName(parts) {
    return parts.length > 1;
}
